import axios from "axios";
import store from "../store";
import router, {FROM_PAGE, ROUTES_NAMES} from "../router";
import {ERROR_RESPONSE_MESSAGE} from "../helpers/axios_requests";
import constants from "../helpers/constants";

axios.defaults.baseURL = constants.api_url
axios.defaults.headers.common['Cache-Control'] = 'no-cache';
axios.interceptors.request.use(function (config) {
  config.headers.common['Content-Language'] = store.getters.getSelectedLanguage;
  if (store.getters.getUserToken) {
    config.headers.common['Authorization'] = `Bearer ${store.getters.getUserToken}`;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});
axios.interceptors.response.use(
  response => response,
  error => {
    switch (error.response.status) {
      case 401:
        if (router.app?.$route
          && router.app?.$route?.matched?.some(el => el.meta.auth)
          && !router.app?.$route?.matched?.some(el => el.name === ROUTES_NAMES.login)
          && router.app?.$route.name !== ROUTES_NAMES.login
        ) {
          store.dispatch('actionLogoutUser', {from_page: FROM_PAGE()})
        }
        break
      case 404:
        router.push({name: ROUTES_NAMES.page_404})
        break
    }
    ERROR_RESPONSE_MESSAGE(error)
    // console.error(error);
    return Promise.reject(error);
  }
);
